export default __webpack_public_path__ + "static/img3-3f3f551971e37326df38e0e09cc980a3.png";